import { Reducer } from "@ctra/utils";
import * as _ from "lodash";

import { cleanup } from "../../utils/reducer";
import types from "./types";
import { FarmList, SiteCollection } from "./typings";
import { NormalizedFarmList } from "./schemas";

export const initialState: FarmList = {};

/**
 * Reducer for farm lists
 * @param state
 * @param action
 * @category Reducer
 */
export const reducer: Reducer<FarmList> = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.FETCH_FARM_LIST.fulfilled: {
      const {
        entities: { farm }
      } = payload as NormalizedFarmList;

      const filtered = _.mapValues(_.defaultTo(farm, {}), ({ herdGroups, pens, ...rest }) => {
        const penIDList = _.map(_.filter(pens, _.matchesProperty("schema", "pen")), "id");
        const herdGroupIDList = _.map(_.filter(pens, _.matchesProperty("schema", "herdGroup")), "id");

        return {
          ...rest,
          herdGroups: _.uniq(_.concat(herdGroups, herdGroupIDList)),
          pens: penIDList
        };
      });

      return _.merge({}, state, filtered);
    }
    case types.FETCH_DATA_INTEGRATIONS.fulfilled: {
      const {
        dataIntegrations: {
          data: { integrations }
        },
        farmID
      } = payload;

      return {
        ...state,
        [farmID]: {
          ...state[farmID],
          integrations
        }
      };
    }
  }

  return state;
};

export default cleanup<FarmList>(initialState)(reducer);

/**
 * Reducer for sites
 * @type {(state: SiteCollection, action: Action) => SiteCollection}
 */
export const siteReducer = cleanup<SiteCollection>({})((state, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.FETCH_FARM_LIST.fulfilled: {
      const {
        entities: { site }
      } = payload as NormalizedFarmList;

      return _.merge({}, state, site);
    }
  }

  return state;
});
